import { parseTransformer } from '@sellpy/commons'

export const CACHE_ENTITIES = 'CACHE_ENTITIES'
export const cacheEntities = (data) => ({
  type: CACHE_ENTITIES,
  entities: parseTransformer.normalize(data)
})
